import LTR from "@brand-icons/ploom/pin-store-default/pin-store-default-ltr.svg";

import { iconFactory } from "../iconFactory";

export const PinStoreDefaultIcon = iconFactory("PinStoreDefaultIcon", LTR);
